export default __webpack_public_path__ + "static/media/Ashley_Day_AHV_In_Moms_We_Trust.4b845e62.jpg";